// extracted by mini-css-extract-plugin
export default {"tags":"Tags_tags__iciZr","tag":"Tags_tag__5BWFj"};